class ProductShipping extends HTMLElement {
  constructor() {
    super();
    this.daysData = JSON.parse(this.querySelector('[data-type="days"]').textContent);
    this.excludedDates = JSON.parse(this.querySelector('[data-type="excluded-dates"]').textContent);
    this.text = this.querySelector('span');
    this.test = this.querySelector('div.test');

    this.init();
  }

  init() {
    const shippingDate = this.getShippingDate();
    const deliveryDate = this.getDeliveryDate(shippingDate);

    // console.log('Today:', new Date().toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }));  
    // console.log('Shipping Date:', shippingDate.toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
    // console.log('Delivery Date:', deliveryDate.toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
    // // combine above 3 console.log statements into one, and add them to this.test, with variables for all three:
    // const today = new Date().toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
    // const shipping = shippingDate.toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    // const delivery = deliveryDate.toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    // const excluddDatesText = this.excludedDates.join(', ');
    // this.test.innerHTML = `Huidige tijd en datum: ${today}<br /> Wordt verzonden op: ${shipping}<br /> Wordt bezorgd op: ${delivery}<br /> Uitgesloten data: ${excluddDatesText}`;



    this.displayShippingDate(deliveryDate);

  }
  

  isDateExcluded(date) {
    const dateString = date.toISOString().split('T')[0];
    return this.excludedDates.includes(dateString);
  }


  getShippingDate() {
    let date = new Date(); // Start with today
    const todayIndex = date.getDay();
    const currentMinutes = date.getHours() * 60 + date.getMinutes();
    const cutoffMinutes = this.getCutoffMinutes(this.daysData[todayIndex].time);
    let attempts = 0; // Initialize attempt counter
  
    // If it's before the cutoff time and shipping is possible today, return today as the shipping date
    if (currentMinutes <= cutoffMinutes && this.isShippingPossible(date) && !this.isDateExcluded(date)) {
      return date;
    }
  
    // If it's after the cutoff or shipping isn't possible/excluded today, find the next valid shipping day
    do {
      date.setDate(date.getDate() + 1); // Move to the next day
      attempts++; // Increment the attempt counter
      if (!this.isDateExcluded(date) && this.isShippingPossible(date)) {
        return date; // Found the shipping date
      }
    } while (attempts < 7); // Limit the search to the next 7 days

    throw new Error("Unable to find a valid shipping date within the next 7 days.");
  }

  getCutoffMinutes(time) {
    let [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
    return hours * 60 + minutes;
  }

  isShippingPossible(date) {
    const dayIndex = date.getDay();
    return this.daysData[dayIndex].shipping_possible;
  }

  getDeliveryDate(shippingDate) {
    let date = new Date(shippingDate);
    date.setDate(date.getDate() + 1); // Start checking from the day after shipping
    let attempts = 0; // Initialize attempt counter

  
    // Find the first day where delivery is possible and not excluded
    while (attempts < 7) { // Limit the search to the next 7 days
      if (!this.isDateExcluded(date) && this.isDeliveryPossible(date)) {
        return date; // Found the delivery date
      }
      date.setDate(date.getDate() + 1); // Move to the next day
      attempts++; // Increment the attempt counter
    }

    throw new Error("Unable to find a valid delivery date within the next 7 days.");
  }
  

  isDeliveryPossible(date) {
    const dayIndex = date.getDay();
    return this.daysData[dayIndex].delivery_possible;
  }
  
  isDateExcluded(date) {
    const dateString = date.toISOString().split('T')[0];
    return this.excludedDates.includes(dateString);
  }

  displayShippingDate(day) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    if (day.toLocaleDateString() === tomorrow.toLocaleDateString()) {
      this.showShippingTomorrow(); // If the valid delivery day is tomorrow, show 'delivered tomorrow'
    } else {
      this.showShippingDate(day.toLocaleDateString(Shopify.locale, { weekday: 'long' }));
    }
  }

  showShippingDate(day) {
    this.text.textContent = window.shippingStrings.available.replace('[day]', day);
}

  showShippingTomorrow() {
      this.text.textContent = window.shippingStrings.available.replace('[day]', window.shippingStrings.tomorrow);
  }

}

customElements.define('product-shipping', ProductShipping);
